import { setContext, getContext } from "svelte";

class MarketingContext {
  page = $state(
    window.location.pathname === "/marketing"
      ? new URLSearchParams(window.location.search).get("page") || "/dashboard"
      : window.location.pathname,
  );
}

const KEY = Symbol("marketing-page");

export const createMarketingPageContext = () => {
  const ctx = new MarketingContext();
  setContext(KEY, ctx);
  return ctx;
};

export const getMarketingPageContext = () => getContext(KEY);
